export enum EAnalyticsEventType {
  /* На экране появился попап с окном ввода номера телефона */
  onPhoneScreenShown = 'phoneScreenShown',
  /* Клик на подтверждение номера телефона */
  onPhoneScreenConfirm = 'phoneScreenConfirm',
  /* На экране появился попап с окном ввода кода из СМС */
  onCodeScreenShown = 'codeScreenShown',
  /* Клик на подтверждение кода из СМС */
  onCodeScreenConfirm = 'codeScreenConfirm',
  /* Клик на прислать новый СМС-код */
  onCodeScreenResend = 'codeScreenResend',
  /* При успешной авторизации дано согласие на рекламу */
  onAdvertisingConsent = 'advertisingConsent',
  /* Успешная авторизация */
  AuthSuccess = 'authSuccess',
  /* Показ пустой выдачи предложений после завершения загрузки */
  EmptyOffersListingShown = 'emptyOffersListingShown',
}
